import cx from 'classnames';
import styles from './SocialLinks.module.scss';
import IconFacebook from 'ui/icons/icon_facebook.svg';
import IconX from 'ui/icons/icon_x.svg';
import IconYouTube from 'ui/icons/icon_youtube.svg';
import IconInstagram from 'ui/icons/icon_instagram.svg';
import IconLinkedIn from 'ui/icons/icon_linkedin.svg';
import { Link } from 'ui/components/1-atoms/Action/Link/Link';
import { Icon } from 'ui/components/1-atoms/Media';

export interface SocialLinksProps {
	className?: string;
	items?: Models.SocialLink[];
	theme: UI.GeneralColorTheme;
}

export const SocialLinks: React.FC<SocialLinksProps> = ({ className, items, theme = 'dark' }) => {
	if (!items) {
		return null;
	}

	const renderIcon = (item: Models.SocialLink) => {
		switch (item.type) {
			case 'facebook':
				return <IconFacebook className={`icon-${item.type}`} aria-hidden="true" />;
			case 'x':
				return <IconX className={`icon-${item.type}`} aria-hidden="true" />;
			case 'youtube':
				return <IconYouTube className={`icon-${item.type}`} aria-hidden="true" />;
			case 'instagram':
				return <IconInstagram className={`icon-${item.type}`} aria-hidden="true" />;
			case 'linkedin':
				return <IconLinkedIn className={`icon-${item.type}`} aria-hidden="true" />;
		}
	};

	return (
		<ul className={cx(styles.SocialLinks, styles[`SocialLinks___theme-${theme}`], className)}>
			{items.map((item, index) => (
				<li key={index} className={styles.SocialLinks_item}>
					<Link className={styles.SocialLinks_link} aria-label={item.title} url={item.url} {...item}>
						<Icon className={styles.SocialLinks_icon} title={item.title} size={'xl'}>
							{renderIcon(item)}
						</Icon>
					</Link>
				</li>
			))}
		</ul>
	);
};
